import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import Nav from "../components/landing/Nav";
import TrustStrip from "../components/landing/TrustStrip";
import Features from "../components/landing/Features";
import HowItWorks from "../components/landing/HowItWorks";
import FreeCalculator from "../components/landing/FreeCalculator";
import ClientOps from "../components/landing/ClientOps";
import FinancialClarity from "../components/landing/FinancialClarity";
import MissionStatement from "../components/landing/MissionStatement";
import QuickEnrol from "../components/landing/QuickEnrol";
import LearnHub from "../components/landing/LearnHub";
import Pricing from "../components/landing/Pricing";
import Testimonials from "../components/landing/Testimonials";
import FAQ from "../components/landing/FAQ";
import CheckoutDialog from "../components/landing/CheckoutDialog";
import ContactDialog from "../components/landing/ContactDialog";
import Footer from "../components/landing/Footer";
import { toast } from "sonner";
import { useSearchParams } from "react-router-dom";

export default function Landing() {
  const [selected, setSelected] = useState(null); // {entity, plan}
  const [open, setOpen] = useState(false);
  const [contactOpen, setContactOpen] = useState(false);
  const [searchParams] = useSearchParams();

  useEffect(() => {
    if (searchParams.get("cancelled") === "1") {
      toast.info("Checkout cancelled. You can pick another plan any time.");
    }
  }, [searchParams]);

  const handleSelect = (entity, plan) => {
    setSelected({ entity, plan });
    setOpen(true);
  };

  return (
    <motion.main
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.4 }}
      className="min-h-screen bg-[#FAFAFA] text-[#0F172A]"
      data-testid="landing-page"
    >
      <Nav
        onCtaClick={() => document.getElementById("pricing")?.scrollIntoView({ behavior: "smooth" })}
        onContactClick={() => setContactOpen(true)}
      />
      <FinancialClarity />
      <ClientOps />
      <MissionStatement />
      <QuickEnrol />
      <TrustStrip />
      <Features />
      <HowItWorks />
      <Pricing onSelect={handleSelect} />
      <FreeCalculator />
      <LearnHub />
      <Testimonials />
      <FAQ />
      <Footer />

      <CheckoutDialog
        open={open}
        onOpenChange={setOpen}
        selected={selected}
      />
      <ContactDialog open={contactOpen} onOpenChange={setContactOpen} />
    </motion.main>
  );
}
